module.exports = __webpack_public_path__ + "img/OFICINA TECNICA.8d038770.png";